export default {
  data() {
    return {
      form: {
        email: '',
      },
      validation: {},
      message: {
        status: null,
        text: null,
      },
    };
  },
  methods: {
    initValidation() {
      this.validation = {
        email: {
          valid: null,
          message: '',
        },
      };
    },
    async onSubmit() {
      this.initValidation();
      this.message = {
        status: null,
        text: null,
      };

      const loader = this.$loading.show();

      try {
        const response = await this.axios.post('customers/forgot_password',
            this.form);
        this.message.text = response.data.message;

        if (response.data.success) {
          this.message.status = 'success';
          this.form.email = '';
        } else {
          this.message.status = 'danger';
          response.data.errors.forEach((error) => {
            if (typeof this.validation[error.field] !== 'undefined') {
              this.validation[error.field].valid = false;
              this.validation[error.field].message = error.message;
            }
          });
        }
        loader.hide();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        loader.hide();
      }
    },
  },
  created() {
    this.initValidation();

    if (this.user) {
      this.$router.push(this.i18nLink('/'));
    }
  },
};
